module.exports = [
  {
    id: "1",
    word: "吃"
  },
  {
    id: "7",
    word: "爱"
  },
  {
    id: "8",
    word: "摔倒"
  },
  {
    id: "16",
    word: "眼睛"
  },
  {
    id: "21",
    word: "门"
  },
  {
    id: "26",
    word: "夜晚"
  },
  {
    id: "46",
    word: "名字"
  },
  {
    id: "48",
    word: "窗户"
  },
  {
    id: "52",
    word: "野生的"
  },
  {
    id: "54",
    word: "做"
  },
  {
    id: "58",
    word: "拿"
  },
  {
    id: "59",
    word: "锻炼"
  },
  {
    id: "63",
    word: "墙壁"
  },
  {
    id: "67",
    word: "地板"
  },
  {
    id: "69",
    word: "结局"
  },
  {
    id: "75",
    word: "神"
  },
  {
    id: "76",
    word: "星期"
  },
  {
    id: "80",
    word: "头脑"
  },
  {
    id: "83",
    word: "嘴"
  },
  {
    id: "84",
    word: "一百"
  },
  {
    id: "85",
    word: "杯子"
  },
  {
    id: "88",
    word: "突发事件           "
  },
  {
    id: "93",
    word: "外表"
  },
  {
    id: "97",
    word: "兄弟"
  },
  {
    id: "99",
    word: "城市"
  },
  {
    id: "104",
    word: "跑"
  },
  {
    id: "106",
    word: "制作"
  },
  {
    id: "108",
    word: "看"
  },
  {
    id: "110",
    word: "飞"
  },
  {
    id: "114",
    word: "丑陋的"
  },
  {
    id: "115",
    word: "想法"
  },
  {
    id: "117",
    word: "彩票"
  },
  {
    id: "119",
    word: "职业"
  },
  {
    id: "126",
    word: "简单的"
  },
  {
    id: "127",
    word: "死亡"
  },
  {
    id: "128",
    word: "诚实的"
  },
  {
    id: "131",
    word: "脚步"
  },
  {
    id: "132",
    word: "血"
  },
  {
    id: "137",
    word: "建筑"
  },
  {
    id: "138",
    word: "号码"
  },
  {
    id: "140",
    word: "父母"
  },
  {
    id: "141",
    word: "角落"
  },
  {
    id: "143",
    word: "老鼠"
  },
  {
    id: "148",
    word: "难过的"
  },
  {
    id: "150",
    word: "箱子"
  },
  {
    id: "152",
    word: "阅读"
  },
  {
    id: "155",
    word: "活"
  },
  {
    id: "159",
    word: "希望"
  },
  {
    id: "160",
    word: "对…感兴趣"
  },
  {
    id: "163",
    word: "右边"
  },
  {
    id: "165",
    word: "懒惰的"
  },
  {
    id: "167",
    word: "块"
  },
  {
    id: "169",
    word: "虚弱的"
  },
  {
    id: "174",
    word: "访客"
  },
  {
    id: "175",
    word: "女士"
  },
  {
    id: "176",
    word: "脖子"
  },
  {
    id: "179",
    word: "武器"
  },
  {
    id: "180",
    word: "石头"
  },
  {
    id: "186",
    word: "田地"
  },
  {
    id: "189",
    word: "第六的"
  },
  {
    id: "190",
    word: "严格的"
  },
  {
    id: "191",
    word: "晚上"
  },
  {
    id: "194",
    word: "梦"
  },
  {
    id: "198",
    word: "夏天"
  },
  {
    id: "199",
    word: "苗条的"
  },
  {
    id: "200",
    word: "沉默"
  },
  {
    id: "203",
    word: "散步"
  },
  {
    id: "205",
    word: "遗失"
  },
  {
    id: "207",
    word: "打"
  },
  {
    id: "211",
    word: "灰"
  },
  {
    id: "213",
    word: "力量"
  },
  {
    id: "218",
    word: "第七的"
  },
  {
    id: "232",
    word: "木头"
  },
  {
    id: "237",
    word: "牙齿"
  },
  {
    id: "238",
    word: "账单"
  },
  {
    id: "240",
    word: "开心的"
  },
  {
    id: "241",
    word: "星星"
  },
  {
    id: "251",
    word: "找到"
  },
  {
    id: "256",
    word: "停留"
  },
  {
    id: "259",
    word: "悬挂"
  },
  {
    id: "260",
    word: "赢"
  },
  {
    id: "265",
    word: "中心"
  },
  {
    id: "273",
    word: "瓶子"
  },
  {
    id: "274",
    word: "六个"
  },
  {
    id: "282",
    word: "教堂"
  },
  {
    id: "285",
    word: "一个"
  },
  {
    id: "288",
    word: "害羞的"
  },
  {
    id: "299",
    word: "新的"
  },
  {
    id: "300",
    word: "机器"
  },
  {
    id: "301",
    word: "感到疼痛"
  },
  {
    id: "306",
    word: "勇敢的"
  },
  {
    id: "307",
    word: "醒来"
  },
  {
    id: "310",
    word: "卖"
  },
  {
    id: "312",
    word: "地区"
  },
  {
    id: "317",
    word: "镜子"
  },
  {
    id: "321",
    word: "洞"
  },
  {
    id: "322",
    word: "可能的"
  },
  {
    id: "328",
    word: "困难的"
  },
  {
    id: "330",
    word: "骨头"
  },
  {
    id: "331",
    word: "有礼貌的"
  },
  {
    id: "332",
    word: "船长"
  },
  {
    id: "338",
    word: "漂亮的"
  },
  {
    id: "340",
    word: "驴子"
  },
  {
    id: "349",
    word: "杯子"
  },
  {
    id: "356",
    word: "开车"
  },
  {
    id: "357",
    word: "搬运"
  },
  {
    id: "360",
    word: "表示…的意思"
  },
  {
    id: "362",
    word: "相似的"
  },
  {
    id: "372",
    word: "收音机"
  },
  {
    id: "374",
    word: "波浪"
  },
  {
    id: "376",
    word: "拼图"
  },
  {
    id: "380",
    word: "商店"
  },
  {
    id: "384",
    word: "北"
  },
  {
    id: "386",
    word: "公共汽车"
  },
  {
    id: "389",
    word: "决定性的"
  },
  {
    id: "397",
    word: "十个"
  },
  {
    id: "404",
    word: "慷慨的"
  },
  {
    id: "405",
    word: "白色的"
  },
  {
    id: "410",
    word: "造成"
  },
  {
    id: "411",
    word: "睡眠"
  },
  {
    id: "415",
    word: "二十个"
  },
  {
    id: "417",
    word: "零"
  },
  {
    id: "421",
    word: "有风的"
  },
  {
    id: "422",
    word: "村庄"
  },
  {
    id: "424",
    word: "流行的"
  },
  {
    id: "428",
    word: "队"
  },
  {
    id: "429",
    word: "快速的"
  },
  {
    id: "432",
    word: "发送"
  },
  {
    id: "436",
    word: "侵略性的"
  },
  {
    id: "438",
    word: "叶子"
  },
  {
    id: "439",
    word: "给…看"
  },
  {
    id: "448",
    word: "轮子"
  },
  {
    id: "452",
    word: "脏的"
  },
  {
    id: "457",
    word: "杀死"
  },
  {
    id: "459",
    word: "切"
  },
  {
    id: "464",
    word: "慢的"
  },
  {
    id: "465",
    word: "角"
  },
  {
    id: "466",
    word: "便宜的"
  },
  {
    id: "469",
    word: "春天"
  },
  {
    id: "470",
    word: "贵的"
  },
  {
    id: "471",
    word: "富有的"
  },
  {
    id: "477",
    word: "胸部"
  },
  {
    id: "480",
    word: "小的"
  },
  {
    id: "481",
    word: "穷的"
  },
  {
    id: "482",
    word: "大的"
  },
  {
    id: "483",
    word: "语言"
  },
  {
    id: "487",
    word: "酒"
  },
  {
    id: "488",
    word: "靴子"
  },
  {
    id: "489",
    word: "无聊的"
  },
  {
    id: "491",
    word: "辣的"
  },
  {
    id: "492",
    word: "飞机"
  },
  {
    id: "493",
    word: "宽的"
  },
  {
    id: "498",
    word: "早的"
  },
  {
    id: "499",
    word: "主人"
  },
  {
    id: "504",
    word: "坏的"
  },
  {
    id: "510",
    word: "解决方法"
  },
  {
    id: "512",
    word: "大小"
  },
  {
    id: "517",
    word: "紫色的"
  },
  {
    id: "519",
    word: "相等的"
  },
  {
    id: "522",
    word: "仅仅"
  },
  {
    id: "523",
    word: "单独地"
  },
  {
    id: "533",
    word: "有雾的"
  },
  {
    id: "535",
    word: "努力"
  },
  {
    id: "544",
    word: "红色的"
  },
  {
    id: "545",
    word: "手机"
  },
  {
    id: "555",
    word: "攻击"
  },
  {
    id: "556",
    word: "发明"
  },
  {
    id: "557",
    word: "爱上某人"
  },
  {
    id: "558",
    word: "抓住"
  },
  {
    id: "561",
    word: "不健康的"
  },
  {
    id: "566",
    word: "沙子"
  },
  {
    id: "568",
    word: "第四的"
  },
  {
    id: "571",
    word: "约会"
  },
  {
    id: "572",
    word: "自然"
  },
  {
    id: "574",
    word: "表兄弟姐妹"
  },
  {
    id: "577",
    word: "更好的"
  },
  {
    id: "580",
    word: "想起"
  },
  {
    id: "581",
    word: "人类"
  },
  {
    id: "582",
    word: "强壮的"
  },
  {
    id: "587",
    word: "美"
  },
  {
    id: "589",
    word: "铃"
  },
  {
    id: "590",
    word: "人"
  },
  {
    id: "591",
    word: "画"
  },
  {
    id: "592",
    word: "列表"
  },
  {
    id: "592",
    word: "重要的"
  },
  {
    id: "599",
    word: "冷的"
  },
  {
    id: "600",
    word: "电视机"
  },
  {
    id: "621",
    word: "效果"
  },
  {
    id: "623",
    word: "远见"
  },
  {
    id: "626",
    word: "性格"
  },
  {
    id: "634",
    word: "错误的"
  },
  {
    id: "642",
    word: "蜂蜜"
  },
  {
    id: "648",
    word: "晴朗的"
  },
  {
    id: "652",
    word: "创造性的"
  },
  {
    id: "653",
    word: "已婚的"
  },
  {
    id: "654",
    word: "愤怒的"
  },
  {
    id: "655",
    word: "笃信宗教的"
  },
  {
    id: "656",
    word: "大声叫嚷"
  },
  {
    id: "663",
    word: "决定"
  },
  {
    id: "665",
    word: "力量"
  },
  {
    id: "671",
    word: "臀部"
  },
  {
    id: "682",
    word: "能量"
  },
  {
    id: "683",
    word: "绿色的"
  },
  {
    id: "684",
    word: "四分之一"
  },
  {
    id: "691",
    word: "观点"
  },
  {
    id: "693",
    word: "惊骇"
  },
  {
    id: "695",
    word: "简单的"
  },
  {
    id: "703",
    word: "各种各样的"
  },
  {
    id: "704",
    word: "推"
  },
  {
    id: "705",
    word: "深的"
  },
  {
    id: "707",
    word: "没什么"
  },
  {
    id: "719",
    word: "喝"
  },
  {
    id: "723",
    word: "多久一次"
  },
  {
    id: "730",
    word: "长的"
  },
  {
    id: "731",
    word: "眉毛"
  },
  {
    id: "732",
    word: "悲观的"
  },
  {
    id: "736",
    word: "方形"
  },
  {
    id: "743",
    word: "好的"
  },
  {
    id: "752",
    word: "或"
  },
  {
    id: "759",
    word: "闹钟"
  },
  {
    id: "760",
    word: "信任"
  },
  {
    id: "763",
    word: "部门"
  },
  {
    id: "771",
    word: "肘部"
  },
  {
    id: "781",
    word: "十年"
  },
  {
    id: "790",
    word: "树莓"
  },
  {
    id: "797",
    word: "物体"
  },
  {
    id: "798",
    word: "年轻的"
  },
  {
    id: "810",
    word: "品尝"
  },
  {
    id: "811",
    word: "棒棒糖"
  },
  {
    id: "820",
    word: "计划"
  },
  {
    id: "821",
    word: "例子"
  },
  {
    id: "822",
    word: "架子"
  },
  {
    id: "824",
    word: "肿瘤"
  },
  {
    id: "830",
    word: "运动员"
  },
  {
    id: "863",
    word: "电线"
  },
  {
    id: "872",
    word: "未知的"
  },
  {
    id: "878",
    word: "包裹"
  },
  {
    id: "888",
    word: "郊狼"
  },
  {
    id: "896",
    word: "蓝色的"
  },
  {
    id: "899",
    word: "养鱼缸"
  },
  {
    id: "901",
    word: "宫殿"
  },
  {
    id: "904",
    word: "粉色的"
  },
  {
    id: "918",
    word: "好处"
  },
  {
    id: "925",
    word: "邮件"
  },
  {
    id: "929",
    word: "射击"
  },
  {
    id: "932",
    word: "外星人"
  },
  {
    id: "941",
    word: "目击者"
  },
  {
    id: "947",
    word: "刺猬"
  },
  {
    id: "949",
    word: "演讲"
  },
  {
    id: "950",
    word: "黑色的"
  },
  {
    id: "952",
    word: "面试"
  },
  {
    id: "953",
    word: "伤疤"
  },
  {
    id: "963",
    word: "药丸"
  },
  {
    id: "965",
    word: "饿的"
  },
  {
    id: "968",
    word: "有趣的"
  },
  {
    id: "982",
    word: "认真的"
  },
  {
    id: "983",
    word: "毒药"
  },
  {
    id: "992",
    word: "酒"
  },
  {
    id: "1002",
    word: "偷听"
  },
  {
    id: "1003",
    word: "要求"
  },
  {
    id: "1005",
    word: "诱惑"
  },
  {
    id: "1008",
    word: "感到尴尬"
  },
  {
    id: "1009",
    word: "扫视"
  },
  {
    id: "1011",
    word: "线"
  },
  {
    id: "1015",
    word: "兑换"
  },
  {
    id: "1018",
    word: "防护"
  },
  {
    id: "1020",
    word: "蚌"
  },
  {
    id: "1021",
    word: "社团"
  },
  {
    id: "1022",
    word: "得分"
  },
  {
    id: "1023",
    word: "胶带"
  },
  {
    id: "1024",
    word: "夫妇"
  },
  {
    id: "1026",
    word: "一打"
  },
  {
    id: "1029",
    word: "手铐"
  },
  {
    id: "1030",
    word: "企图"
  },
  {
    id: "1032",
    word: "故意地"
  },
  {
    id: "1036",
    word: "综合的"
  },
  {
    id: "1039",
    word: "关心"
  },
  {
    id: "1040",
    word: "新闻"
  },
  {
    id: "1042",
    word: "社会"
  },
  {
    id: "1045",
    word: "命令"
  },
  {
    id: "1046",
    word: "秒"
  },
  {
    id: "1047",
    word: "模特"
  },
  {
    id: "1048",
    word: "坦克"
  },
  {
    id: "1050",
    word: "换气扇"
  },
  {
    id: "1052",
    word: "植物"
  },
  {
    id: "1064",
    word: "沙漏"
  },
  {
    id: "1065",
    word: "箱子"
  },
  {
    id: "1066",
    word: "自行车运动"
  },
  {
    id: "1071",
    word: "顶峰"
  },
  {
    id: "1076",
    word: "戏法"
  },
  {
    id: "1079",
    word: "换挡"
  },
  {
    id: "1083",
    word: "薄的"
  },
  {
    id: "1086",
    word: "高度"
  },
  {
    id: "1089",
    word: "地雷"
  },
  {
    id: "1090",
    word: "确认"
  },
  {
    id: "1093",
    word: "使加倍"
  },
  {
    id: "1094",
    word: "手枪"
  },
  {
    id: "1096",
    word: "露营"
  },
  {
    id: "1101",
    word: "提及"
  },
  {
    id: "1102",
    word: "摔跤"
  },
  {
    id: "1104",
    word: "举起"
  },
  {
    id: "1109",
    word: "抓住"
  },
  {
    id: "1111",
    word: "自动提款机"
  },
  {
    id: "1112",
    word: "马术"
  },
  {
    id: "1119",
    word: "较少的"
  },
  {
    id: "1130",
    word: "减"
  },
  {
    id: "1132",
    word: "角"
  },
  {
    id: "1136",
    word: "攀登"
  },
  {
    id: "1137",
    word: "更多的"
  },
  {
    id: "1140",
    word: "青年时期"
  },
  {
    id: "1141",
    word: "吹"
  },
  {
    id: "1143",
    word: "涉及"
  },
  {
    id: "1147",
    word: "给…调味"
  },
  {
    id: "1150",
    word: "介绍"
  },
  {
    id: "1153",
    word: "睡过头"
  },
  {
    id: "1155",
    word: "演出"
  },
  {
    id: "1157",
    word: "世界锦标赛"
  },
  {
    id: "1159",
    word: "磨蹭"
  },
  {
    id: "1160",
    word: "粉丝"
  },
  {
    id: "1161",
    word: "收藏品"
  },
  {
    id: "1169",
    word: "油"
  },
  {
    id: "1171",
    word: "工具"
  },
  {
    id: "1172",
    word: "直径"
  },
  {
    id: "1174",
    word: "需求"
  },
  {
    id: "1188",
    word: "儿童房"
  },
  {
    id: "1193",
    word: "关闭的"
  },
  {
    id: "1194",
    word: "防热手套"
  },
  {
    id: "1195",
    word: "大肠"
  },
  {
    id: "1198",
    word: "电极"
  },
  {
    id: "1199",
    word: "关系"
  },
  {
    id: "1203",
    word: "汉语"
  },
  {
    id: "1209",
    word: "遭受"
  },
  {
    id: "1222",
    word: "给...以荣誉"
  },
  {
    id: "1227",
    word: "匈牙利语"
  },
  {
    id: "1232",
    word: "毛皮"
  },
  {
    id: "1233",
    word: "部门"
  },
  {
    id: "1234",
    word: "主题"
  },
  {
    id: "1236",
    word: "章节"
  },
  {
    id: "1237",
    word: "倒影"
  },
  {
    id: "1244",
    word: "雪球"
  },
  {
    id: "1245",
    word: "双方都"
  },
  {
    id: "1249",
    word: "花商"
  },
  {
    id: "1251",
    word: "喉咙"
  },
  {
    id: "1253",
    word: "喉结"
  },
  {
    id: "1254",
    word: "与…和睦相处"
  },
  {
    id: "1263",
    word: "油漆"
  },
  {
    id: "1265",
    word: "反击"
  },
  {
    id: "1283",
    word: "工作室"
  },
  {
    id: "1291",
    word: "季节"
  },
  {
    id: "1293",
    word: "羽毛"
  },
  {
    id: "1295",
    word: "五颜六色的"
  },
  {
    id: "1297",
    word: "肥胖的"
  },
  {
    id: "1301",
    word: "折磨"
  },
  {
    id: "1302",
    word: "举报"
  },
  {
    id: "1304",
    word: "斯洛文尼亚"
  },
  {
    id: "1305",
    word: "打招呼"
  },
  {
    id: "1306",
    word: "捷克"
  },
  {
    id: "1309",
    word: "拥有"
  },
  {
    id: "1311",
    word: "高温"
  },
  {
    id: "1313",
    word: "健康的"
  },
  {
    id: "1317",
    word: "失去"
  },
  {
    id: "1318",
    word: "平衡"
  },
  {
    id: "1320",
    word: "术语"
  },
  {
    id: "1321",
    word: "锁"
  },
  {
    id: "1329",
    word: "恶劣的"
  },
  {
    id: "1331",
    word: "法语"
  },
  {
    id: "1342",
    word: "防御"
  },
  {
    id: "1343",
    word: "咬"
  },
  {
    id: "1345",
    word: "帮忙"
  },
  {
    id: "1352",
    word: "开花"
  },
  {
    id: "1354",
    word: "准确的"
  },
  {
    id: "1356",
    word: "提高"
  },
  {
    id: "1361",
    word: "房地产"
  },
  {
    id: "1363",
    word: "燃烧"
  },
  {
    id: "1381",
    word: "橙子"
  },
  {
    id: "1389",
    word: "首页"
  },
  {
    id: "1410",
    word: "度"
  },
  {
    id: "1411",
    word: "响铃"
  },
  {
    id: "1415",
    word: "体积"
  },
  {
    id: "1419",
    word: "痕迹"
  },
  {
    id: "1420",
    word: "疾病"
  },
  {
    id: "1425",
    word: "滴"
  },
  {
    id: "1427",
    word: "破的"
  },
  {
    id: "1456",
    word: "认出"
  },
  {
    id: "1461",
    word: "卷心菜"
  },
  {
    id: "1463",
    word: "饱的"
  },
  {
    id: "1466",
    word: "乐器"
  },
  {
    id: "1468",
    word: "层"
  },
  {
    id: "1475",
    word: "绘画"
  },
  {
    id: "1477",
    word: "智力"
  },
  {
    id: "1485",
    word: "边界"
  },
  {
    id: "1509",
    word: "订购"
  },
  {
    id: "1510",
    word: "喂养"
  },
  {
    id: "1512",
    word: "公牛"
  },
  {
    id: "1523",
    word: "例行公事"
  },
  {
    id: "1529",
    word: "著名的"
  },
  {
    id: "1532",
    word: "贸易"
  },
  {
    id: "1533",
    word: "验光师"
  },
  {
    id: "1540",
    word: "旋转木马"
  },
  {
    id: "1546",
    word: "织物"
  },
  {
    id: "1548",
    word: "雌性的"
  },
  {
    id: "1553",
    word: "让"
  },
  {
    id: "1564",
    word: "女装衬衫"
  },
  {
    id: "1568",
    word: "土耳其语"
  },
  {
    id: "1574",
    word: "扬声器"
  },
  {
    id: "1582",
    word: "天然的"
  },
  {
    id: "1594",
    word: "派"
  },
  {
    id: "1601",
    word: "梳"
  },
  {
    id: "1603",
    word: "煮沸"
  },
  {
    id: "1605",
    word: "空的"
  },
  {
    id: "1607",
    word: "够得上"
  },
  {
    id: "1610",
    word: "丹麦语"
  },
  {
    id: "1611",
    word: "整洁的"
  },
  {
    id: "1618",
    word: "凌乱的"
  },
  {
    id: "1631",
    word: "积极的"
  },
  {
    id: "1634",
    word: "消极的"
  },
  {
    id: "1637",
    word: "百分比"
  },
  {
    id: "1634",
    word: "会员"
  },
  {
    id: "1645",
    word: "血管"
  },
  {
    id: "1647",
    word: "准时的"
  },
  {
    id: "1653",
    word: "把…弄干"
  },
  {
    id: "1655",
    word: "煮饭"
  },
  {
    id: "1660",
    word: "叫"
  },
  {
    id: "1674",
    word: "满的"
  },
  {
    id: "1692",
    word: "中介"
  },
  {
    id: "1696",
    word: "海豹"
  },
  {
    id: "1699",
    word: "干净的"
  },
  {
    id: "1700",
    word: "间隙"
  },
  {
    id: "1701",
    word: "领导力"
  },
  {
    id: "1702",
    word: "开玩笑"
  },
  {
    id: "1703",
    word: "友好的"
  },
  {
    id: "1709",
    word: "唤醒"
  },
  {
    id: "1710",
    word: "装载"
  },
  {
    id: "1714",
    word: "头皮屑"
  },
  {
    id: "1715",
    word: "应当"
  },
  {
    id: "1716",
    word: "锋利的"
  },
  {
    id: "1720",
    word: "分析师"
  },
  {
    id: "1724",
    word: "沉重的"
  },
  {
    id: "1727",
    word: "碰撞"
  },
  {
    id: "1728",
    word: "俄语"
  },
  {
    id: "1729",
    word: "肯定的"
  },
  {
    id: "1735",
    word: "领结"
  },
  {
    id: "1737",
    word: "交易"
  },
  {
    id: "1744",
    word: "钝的"
  },
  {
    id: "1750",
    word: "不运动的"
  },
  {
    id: "1750",
    word: "传统的"
  },
  {
    id: "1758",
    word: "绕口令"
  },
  {
    id: "1765",
    word: "点"
  },
  {
    id: "1767",
    word: "不可思议的"
  },
  {
    id: "1774",
    word: "可爱的"
  },
  {
    id: "1785",
    word: "名声"
  },
  {
    id: "1786",
    word: "情绪化的"
  },
  {
    id: "1799",
    word: "奖励"
  },
  {
    id: "1803",
    word: "加热"
  },
  {
    id: "1804",
    word: "搅动"
  },
  {
    id: "1805",
    word: "发出臭味"
  },
  {
    id: "1808",
    word: "工业的"
  },
  {
    id: "1817",
    word: "水平的"
  },
  {
    id: "1821",
    word: "垂直的"
  },
  {
    id: "1826",
    word: "幸运的"
  },
  {
    id: "1827",
    word: "军队"
  },
  {
    id: "1828",
    word: "膝盖"
  },
  {
    id: "1832",
    word: "冷的"
  },
  {
    id: "1843",
    word: "技术上的"
  },
  {
    id: "1851",
    word: "治愈"
  },
  {
    id: "1852",
    word: "数码的"
  },
  {
    id: "1854",
    word: "装满"
  },
  {
    id: "1858",
    word: "花费"
  },
  {
    id: "1859",
    word: "借出"
  },
  {
    id: "1863",
    word: "神圣的"
  },
  {
    id: "1864",
    word: "单身的"
  },
  {
    id: "1870",
    word: "日语"
  },
  {
    id: "1884",
    word: "计数器"
  },
  {
    id: "1888",
    word: "男朋友"
  },
  {
    id: "1893",
    word: "无知的"
  },
  {
    id: "1903",
    word: "北极熊"
  },
  {
    id: "1907",
    word: "出汗"
  },
  {
    id: "1912",
    word: "手掌"
  },
  {
    id: "1922",
    word: "区域"
  },
  {
    id: "1926",
    word: "门口"
  },
  {
    id: "1928",
    word: "失望"
  },
  {
    id: "1929",
    word: "愚蠢的"
  },
  {
    id: "1933",
    word: "利息"
  },
  {
    id: "1935",
    word: "主张"
  },
  {
    id: "1947",
    word: "铅笔刀"
  },
  {
    id: "1949",
    word: "怀孕的"
  },
  {
    id: "1952",
    word: "创始人"
  },
  {
    id: "1956",
    word: "完成"
  },
  {
    id: "1967",
    word: "被称作"
  },
  {
    id: "1977",
    word: "叛乱者"
  },
  {
    id: "1984",
    word: "服务"
  },
  {
    id: "1986",
    word: "相当"
  },
  {
    id: "1988",
    word: "合乎道德的"
  },
  {
    id: "1999",
    word: "很棒的"
  },
  {
    id: "2005",
    word: "强迫"
  },
  {
    id: "2011",
    word: "说明"
  },
  {
    id: "2020",
    word: "绅士"
  },
  {
    id: "2033",
    word: "住处"
  },
  {
    id: "2035",
    word: "聚光灯"
  },
  {
    id: "2039",
    word: "在线的"
  },
  {
    id: "3347",
    word: "外来的"
  },
  {
    id: "3449",
    word: "合格的"
  }
];



// WEBPACK FOOTER //
// ./src/containers/Words/zh-CN.js